import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { serverInfo } from "../../../../../../App";
import { LocationContext } from "../../../../../../CustomHelper/Helper";
import MyVerticallyCenteredModal from "../../../../../RegisterLearningDetails/RegisterNowPay/MyVerticallyCenteredModal";
import ParticipateReceipt from "../../../../../StarProfile/BookNow/ParticipateReceipt/ParticipateReceipt";
import Countdown from "react-countdown";
import ContdownTimerRender from "../../../../../../CustomHelper/ContdownTimerRender";

const OfflineMeetupActivity = ({ event, event_type }) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [cardModalShow, setCardModalShow] = React.useState(false);
  const [buffer, setBuffer] = useState(false);
  const [pendingPayment, setPendingPayment] = useState();
  const [payAgin, setPayAgin] = useState(false);
  const [alreadyBooked, setSlotAbailability] = useState();
  const { paymentCount, paymentCountWithSymbol, payStatus, countryDateTime } = useContext(LocationContext);

  useEffect(() => {
    if (event_type === "meetup") {
      // setPendingPayment(true)
      axios.get(`api/user/registerMeestup-single/${event?.id}`).then((res) => {
        setBuffer(true);
        if (res.data.status === 200) {
          res.data.event.payment_status == null
            ? setPendingPayment(true)
            : setPendingPayment(false);
          setSlotAbailability(res.data?.totalRegistered);
        }
      });
    }
  }, []);


  const handelDownlodeTicket = () => {
    if (payStatus) {
      setCardModalShow(true)
    } else {
      alert('please select your current country')
    }
  }

  const event_start_time =
    moment(event.event_date).format("LL") + " " + event.start_time;
  const event_end_time =
    moment(event.event_date).format("LL") + " " + event.end_time;

  const event_start = new Date(countryDateTime(event_start_time, '')).getTime();
  const event_end = new Date(countryDateTime(event_end_time, '')).getTime();

  return (
    <>
      {event_start >= new Date().getTime() ? (
        <div class="col-md-6 col-lg-4 mb-3">
          <div className="card text-center CardEnLive ">
            <img src={imageCdnUrl + event.banner} alt="Img1" className="ImgAc" />

            <div className="joinNowBgLive title_text_ellipsis">
              {event.title}
            </div>
            {pendingPayment ? (
              event?.total_seat > alreadyBooked ? (
                <h6
                  className="fw-bold pt-3 pb-1 text-warning EnHeadLive"
                  onClick={() => setPayAgin(true)}
                >
                  <div class="spinner-grow text-warning" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>{" "}
                  Payment pending
                </h6>
              ) : (
                <h6 className="fw-bold pt-3 pb-1 text-warning EnHeadLive">
                  <div class="spinner-grow text-warning" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>{" "}
                  All Seat Over
                </h6>
              )
            ) : (
              <h6
                className="fw-bold pt-3 pb-1 text-warning EnHeadLiveActive"
                onClick={() => handelDownlodeTicket()}
              >
                Download Ticket
              </h6>
            )}
            <Countdown
              date={event_start}
              renderer={ContdownTimerRender} />
          </div>
        </div>
      ) : event_start < new Date().getTime() &&
        event_end > new Date().getTime() ? (
        <div class="col-md-6 col-lg-4 mb-3">
          <div className="card text-center CardEnLive ">
            <img src={imageCdnUrl + event.banner} alt="Img1" className="ImgAc" />

            <div className="joinNowBg">Running...</div>

            <div className="joinNowBgLive title_text_ellipsis">
              {event.title}
            </div>

            <h6 className="fw-bold pt-3 pb-1 text-warning EnHeadLiveActive">
              Meetup Event Running
            </h6>
          </div>
        </div>
      ) : (
        <div class="col-md-6 col-lg-4 mb-3">
          <div className="card text-center CardEn">
            <img src={imageCdnUrl + event.banner} alt="Img1" className="ImgAc" />

            <div className="joinNowBgLive title_text_ellipsis">
              {event.title}
            </div>

            <h6 className="fw-bold pt-3 pb-1 text-danger EnHeadLive">
              Expired
            </h6>
          </div>
        </div>
      )}

      <MyVerticallyCenteredModal
        show={payAgin}
        onHide={() => setPayAgin(false)}
        event_id={event.id}
        event_type={
          event_type === "learning_session" ? "learningSession" : event_type
        }
        redirectTo="activities"
        fee={paymentCount(event.fee)}
        baseFee={event.fee}
      />

      <ParticipateReceipt
        show={cardModalShow}
        onHide={() => setCardModalShow(false)}
        event={event}
      />
    </>
  );
};

export default OfflineMeetupActivity;
